import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  allDate,
  allMonth,
  checkPermision,
  showErrorDialog,
  showSuccessDialog,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { DropzoneArea } from "material-ui-dropzone";

import {
  makeStyles,
  fade,
  ThemeProvider,
  createMuiTheme,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Input from "@material-ui/core/Input";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import FilledInput from "@material-ui/core/FilledInput";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import FormControl from "@material-ui/core/FormControl";
import Select from "react-select";
import {
  fetchParameter,
  fetchParameter2,
  selectParameter,
  selectParameter2,
  selectParameter3,
  selectParameter8,
} from "../businessParameter/businessParameterSlice";

import {
  addOffice,
  addUpload,
  editOffice,
  fetchIdOffice,
  removeImageOffice,
  selectIdOffice,
  selectLoading,
  selectPermissionBasicInfo,
} from "./officeSlice";
import SelectMUI from "@material-ui/core/Select";
import { Autocomplete } from "@material-ui/lab";
import { selectCountryAll } from "../location/locationSlice";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#db3131",
        "&$error": {
          color: "#db3131",
        },
      },
    },
    MuiFormHelperText: {
      root: {
        margin: "1px !important", // Remove the margin
      },
    },
  },
  typography: {
    fontFamily: `"Poppins", "Helvetica", "Arial", sans-serif`,
  },
});

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const BasicInformationTab = ({ active, setActive, types }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataCountry = useSelector(selectCountryAll);
  const data = useSelector(selectIdOffice);
  const dataParam2 = useSelector(selectParameter2);
  const officeParam = useSelector(selectParameter8); // office type

  const permission = useSelector(selectPermissionBasicInfo);

  const [file, setFile] = useState("");

  const [formValues, setFormValues] = useState({
    office_code: {
      value: "",
      error: false,
      required: "Y",
    },
    office_name: {
      value: "",
      error: false,
      required: "Y",
    },
    first_name: {
      value: "",
      error: false,
      required: "N",
    },
    last_name: {
      value: "",
      error: false,
      required: "N",
    },
    address1: {
      value: "",
      error: false,
      required: "Y",
    },
    address2: {
      value: "",
      error: false,
      required: "N",
    },
    office_type: {
      value: "REGIONAL_OFFICE",
      error: false,
      required: "Y",
    },
    city: {
      value: "",
      error: false,
      required: "N",
    },
    zipcode: {
      value: "",
      error: false,
      required: "N",
    },
    country_id: {
      value: "",
      error: false,
      required: "Y",
    },
    province: {
      value: "",
      error: false,
      required: "N",
    },
    email: {
      value: "",
      error: false,
      required: "N",
    },
    finansial_start_day: {
      value: "",
      error: false,
      required: "N",
    },
    finansial_start_month: {
      value: "",
      error: false,
      required: "N",
    },

    contactpersons: [
      {
        phone_type: "",
        phone: "",
      },
    ],
  });

  const [fieldsCP, setFieldsCP] = useState([
    {
      phone_type: "",
      phone: "",
    },
  ]);

  useEffect(() => {
    if (data !== null) {
      setFormValues({
        office_code: {
          value: data.office_code,
          error: false,
          required: "Y",
        },
        office_name: {
          value: data.office_name,
          error: false,
          required: "Y",
        },
        first_name: {
          value: data.first_name,
          error: false,
          required: "N",
        },
        last_name: {
          value: data.last_name,
          error: false,
          required: "N",
        },
        address1: {
          value: data.address1,
          error: false,
          required: "Y",
        },
        address2: {
          value: data.address2,
          error: false,
          required: "N",
        },
        office_type: {
          value: data.office_type,
          error: false,
          required: "Y",
        },
        city: {
          value: data.city,
          error: false,
          required: "N",
        },
        zipcode: {
          value: data.zipcode,
          error: false,
          required: "N",
        },
        country_id: {
          value: data.country_id,
          error: false,
          required: "Y",
        },
        province: {
          value: data.province,
          error: false,
          required: "N",
        },
        email: {
          value: data.email,
          error: false,
          required: "N",
        },
        finansial_start_day: {
          value: data.finansial_start_day,
          error: false,
          required: "N",
        },
        finansial_start_month: {
          value: data.finansial_start_month,
          error: false,
          required: "N",
        },
      });

      const initData =
        data.contactpersons === null
          ? fieldsCP
          : data.contactpersons.map((item, index) => {
              return {
                phone_type: item.phone_type,
                phone: item.phone,
              };
            });

      setFieldsCP(initData);
    }
  }, [data]);

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }
    const params = {
      office_id: data.office_id,
      office_code: formValues.office_code.value,
      office_name: formValues.office_name.value,
      address1: formValues.address1.value,
      address2: formValues.address2.value,
      city: formValues.city.value,
      zipcode: formValues.zipcode.value,
      country_id: formValues.country_id.value,
      province: formValues.province.value,
      office_type: formValues.office_type.value,
      finansial_start_day: formValues.finansial_start_day.value,
      finansial_start_month: formValues.finansial_start_month.value,
      first_name: formValues.first_name.value,
      last_name: formValues.last_name.value,
      email: formValues.email.value,
      contactpersons: fieldsCP.map((item, index) => {
        return {
          phone_type: item.phone_type,
          phone: item.phone,
        };
      }),
    };

    try {
      const response = await dispatch(editOffice(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        if (action.isConfirmed) dispatch(fetchIdOffice(data.office_id));
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const typePhone = dataParam2.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const typeOffice = officeParam.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  function handlePhoneChange(i, event) {
    const values = [...fieldsCP];
    values[i].phone = event.target.value;
    setFieldsCP(values);
  }

  function handleAdd() {
    const values = [...fieldsCP];
    values.push({
      phone_type: "",
      phone: "",
    });
    setFieldsCP(values);
    return true;
  }

  function handleRemove(i) {
    const values = [...fieldsCP];
    values.splice(i, 1);
    setFieldsCP(values);
  }

  const handleTypeChange = (i, event) => {
    const values = [...fieldsCP];
    values[i].phone_type = event.value;
    setFieldsCP(values);
  };

  const getValueType = (value, options) => {
    const return_value = options.filter((val) => value === val.value);
    return return_value;
  };

  const countryOptions = dataCountry.map((e) => {
    return {
      value: e.country_id,
      label: e.country_name,
    };
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };
  const handleChangeCountry = (e, country) => {
    const value = country.value;
    setFormValues({
      ...formValues,
      ["country_id"]: {
        ...formValues["country_id"],
        value,
      },
    });
  };
  const handleChangeOffice = (e, country) => {
    const value = country.value;
    setFormValues({
      ...formValues,
      ["office_type"]: {
        ...formValues["office_type"],
        value,
      },
    });
  };

  const handleChangeFinansial = (event) => {
    const value = event.target.value;
    const name = event.target.name;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const icon = <SVG src={toAbsoluteUrl("/media/svg/icons/New/x-error.svg")} />;
  const index = countryOptions.findIndex(
    (obj) => obj.value === formValues.country_id.value
  );

  const indexOfficeType = typeOffice.findIndex(
    (obj) => obj.value === formValues.office_type.value
  );

  const handleUpload = async () => {
    if (file === undefined) {
      return showErrorDialog("Field can't be empty");
    }

    const params = {
      id: data.office_id,
      file: file,
    };

    try {
      const response = await dispatch(addUpload(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdOffice(data.office_id));
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleDeleteImage = async () => {
    const params = {
      office_id: data.office_id,
    };
    try {
      const response = await dispatch(removeImageOffice(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await dispatch(fetchIdOffice(data.office_id));
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {data && (
        <Card>
          <CardBody>
            <Row>
              <Col md={10}>
                <ButtonToolbar>
                  {types.map((type) => (
                    <Button
                      active={active === type}
                      onClick={() => setActive(type)}
                      variant="outline-primary"
                      className="m-2 "
                    >
                      {type}
                    </Button>
                  ))}
                </ButtonToolbar>
              </Col>

              <Col>
                <Button
                  variant="primary"
                  className="ml-2"
                  onClick={(e) => history.goBack()}
                >
                  Back To List
                </Button>
              </Col>
            </Row>
            <ThemeProvider theme={formLabelsTheme}>
              {active === "General Information" && (
                <CardBody>
                  <div>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          required
                          label="Office Code"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="office_code"
                          value={formValues.office_code.value}
                          onChange={handleChange}
                          error={formValues.office_code.error}
                          helperText={
                            formValues.office_code.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {icon} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />

                        <RedditTextField
                          required
                          label="Address Line 1"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          multiline
                          rows="4"
                          name="address1"
                          value={formValues.address1.value}
                          onChange={handleChange}
                          error={formValues.address1.error}
                          helperText={
                            formValues.address1.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {icon} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                        <RedditTextField
                          label="City"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="city"
                          onChange={handleChange}
                          value={formValues.city.value}
                        />
                        <RedditTextField
                          label="Province"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="province"
                          onChange={handleChange}
                          value={formValues.province.value}
                        />
                        <Autocomplete
                          disablePortal
                          name="office_type"
                          options={typeOffice}
                          getOptionLabel={(option) => option.label.toString()}
                          disableClearable={true}
                          onChange={handleChangeOffice}
                          value={
                            typeOffice.find(
                              (option) =>
                                option.value === formValues.office_type.value
                            ) || null
                          }
                          renderInput={(params) => (
                            <RedditTextField
                              required
                              className={classes.margin}
                              {...params}
                              label="Office Type"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              // placeholder="Office Type"
                              name="office_type"
                            />
                          )}
                        />
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          required
                          label="Name"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="office_name"
                          value={formValues.office_name.value}
                          onChange={handleChange}
                          error={formValues.office_name.error}
                          helperText={
                            formValues.office_name.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {icon} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                        />
                        <RedditTextField
                          label="Address Line 2"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          multiline
                          rows="4"
                          name="address2"
                          onChange={handleChange}
                          value={formValues.address2.value}
                        />
                        <RedditTextField
                          label="Zipcode"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="zipcode"
                          onChange={handleChange}
                          value={formValues.zipcode.value}
                        />
                        <Autocomplete
                          disablePortal
                          name="country_id"
                          options={countryOptions}
                          getOptionLabel={(option) => option.label.toString()}
                          disableClearable={true}
                          onChange={handleChangeCountry}
                          value={
                            countryOptions.find(
                              (option) =>
                                option.value === formValues.country_id.value
                            ) || null
                          }
                          renderInput={(params) => (
                            <RedditTextField
                              required
                              className={classes.margin}
                              {...params}
                              label="Country"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              placeholder="Select Country"
                              name="country_id"
                            />
                          )}
                        />
                        <div className="border-m">
                          <p className="text-muted">Finansial Year starts on</p>
                          <Row>
                            <Col sm={6}>
                              <Row>
                                <Col sm={6}>
                                  {" "}
                                  <FormControl
                                    fullWidth
                                    className={classes.formControl}
                                  >
                                    <SelectMUI
                                      value={
                                        formValues.finansial_start_day.value
                                      }
                                      onChange={handleChangeFinansial}
                                      displayEmpty
                                      name="finansial_start_day"
                                      className={classes.selectEmpty}
                                    >
                                      {allDate.map((item) => (
                                        <MenuItem value={item}>{item}</MenuItem>
                                      ))}
                                    </SelectMUI>
                                  </FormControl>
                                </Col>

                                <Col sm={6}>
                                  {" "}
                                  <p className="mt-3">Day</p>
                                </Col>
                              </Row>
                            </Col>
                            <Col sm={6}>
                              <Row>
                                <Col sm={6}>
                                  {" "}
                                  <FormControl
                                    fullWidth
                                    className={classes.formControl}
                                  >
                                    <SelectMUI
                                      value={
                                        formValues.finansial_start_month.value
                                      }
                                      onChange={handleChange}
                                      displayEmpty
                                      name="finansial_start_month"
                                      className={classes.selectEmpty}
                                    >
                                      {allMonth.map((item) => (
                                        <MenuItem value={item}>{item}</MenuItem>
                                      ))}
                                    </SelectMUI>
                                  </FormControl>
                                </Col>

                                <Col sm={6}>
                                  <p className="mt-3">Month</p>
                                </Col>
                              </Row>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                    <p className="font-weight-bold  m-3">Contact Person :</p>

                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          label="First Name"
                          inputProps={{ maxLength: 128 }}
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="first_name"
                          onChange={handleChange}
                          value={formValues.first_name.value}
                        />
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          label="Last Name"
                          inputProps={{ maxLength: 128 }}
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="last_name"
                          onChange={handleChange}
                          value={formValues.last_name.value}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        {fieldsCP.map((field, idx) => {
                          return (
                            <div key={`${field}-${idx}`}>
                              <Row>
                                <Col md={4}>
                                  <Select
                                    // isClearable={true}
                                    options={typePhone}
                                    value={getValueType(
                                      field.phone_type,
                                      typePhone
                                    )}
                                    placeholder="Type"
                                    onChange={(e) => handleTypeChange(idx, e)}
                                    className="mt-4 ml-3"
                                  />
                                </Col>
                                <Col md={6}>
                                  <RedditTextField
                                    label="Phone Number"
                                    className={classes.margin}
                                    variant="filled"
                                    id="reddit-input"
                                    size="small"
                                    type="number"
                                    fullWidth
                                    value={field.phone || ""}
                                    onChange={(e) => handlePhoneChange(idx, e)}
                                  />
                                </Col>
                                {fieldsCP.length !== 1 && (
                                  <Col>
                                    <div
                                      className="btn btn-icon btn-primary btn-hover-primary btn-sm mt-4 "
                                      onClick={() => handleRemove(idx)}
                                    >
                                      <span className="svg-icon svg-icon-md svg-icon-light">
                                        <SVG
                                          src={toAbsoluteUrl(
                                            "/media/svg/icons/New/X.svg"
                                          )}
                                        />
                                      </span>
                                    </div>
                                  </Col>
                                )}
                                <Col sm={1}>
                                  {fieldsCP.length - 1 === idx && (
                                    <Button
                                      variant="outline-primary"
                                      onClick={(e) => handleAdd()}
                                      className="mt-4 "
                                    >
                                      Add
                                    </Button>
                                  )}
                                </Col>
                              </Row>
                            </div>
                          );
                        })}
                      </Col>

                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          label="Email"
                          inputProps={{ maxLength: 128 }}
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          name="email"
                          onChange={handleChange}
                          value={formValues.email.value}
                        />
                      </Col>
                    </Row>
                  </div>

                  {checkPermision(permission, "UPDATE") && (
                    <Row className="mt-6 justify-content-end">
                      <Button variant="primary" onClick={handleSave}>
                        Save
                      </Button>
                    </Row>
                  )}
                </CardBody>
              )}
              {active === "Co-Branding" && (
                <CardBody>
                  <>
                    <DropzoneArea
                      acceptedFiles={["image/*"]}
                      dropzoneText={"Drag and drop an image here or click"}
                      onChange={(files) => setFile(files[0])}
                    />
                    {checkPermision(permission, "UPDATE") && (
                      <Row className="mt-6 justify-content-end">
                        <Button variant="primary" onClick={handleUpload}>
                          Save
                        </Button>
                      </Row>
                    )}

                    <>
                      {data.co_branding !== null && (
                        <Row>
                          <div>
                            <h3 className="mb-5 mr-5">
                              Last Image Upload : {data.co_branding}
                            </h3>
                            <div
                              className="btn btn-icon btn-primary btn-hover-primary btn-sm mt-4 mr-4    "
                              onClick={() => {
                                window
                                  .open(data.co_branding_url, "_blank")
                                  .focus();
                              }}
                            >
                              <span className="svg-icon svg-icon-md svg-icon-light">
                                <SVG
                                  src={toAbsoluteUrl(
                                    "/media/svg/icons/Design/Image.svg"
                                  )}
                                />
                              </span>
                            </div>
                            {checkPermision(permission, "DELETE") && (
                              <div
                                className="btn btn-icon btn-primary btn-hover-primary btn-sm mt-4 mr-4  "
                                onClick={handleDeleteImage}
                              >
                                <span className="svg-icon svg-icon-md svg-icon-light">
                                  <SVG
                                    src={toAbsoluteUrl(
                                      "/media/svg/icons/New/delete.svg"
                                    )}
                                  />
                                </span>
                              </div>
                            )}
                          </div>
                        </Row>
                      )}
                    </>
                  </>
                </CardBody>
              )}
            </ThemeProvider>
          </CardBody>
        </Card>
      )}
    </>
  );
};
